import clsx from 'clsx';

import { Button, Link } from '@/components/core';
import { IconsId } from '@/types/icons';
import { MultilinkStoryblok } from '@/types/storyblok/storyblok-types';
import { parseStoryblokUrl } from '@/utils/storyblok';

import styles from './Button.module.scss';

type ButtonProps = {
    link: MultilinkStoryblok;
    text: string;
    className?: string;
    classButton?: string;
    iconName?: IconsId;
};

export const ButtonLink: React.FC<ButtonProps> = ({ link, text, className, classButton, iconName }) => (
    <div className={clsx(styles.root, className)}>
        <Link
            className={styles.link}
            href={parseStoryblokUrl(link.cached_url)}
            target={link.target}
        >
            <Button
                className={clsx(styles.button, classButton)}
                iconName={iconName}
            >
                {text}
            </Button>
        </Link>
    </div>
);
